$(document).ready(function() {
    // Check if screen is mobile
    const isMobile = (checkWidth) => $(window).width() < checkWidth;

    // Store the instance in a variable so you can access it later
    const phoneInput = document.querySelector("input[name='phone_number']");
    let iti;
    if(phoneInput){
        iti = window.intlTelInput(phoneInput, {
            initialCountry: "ae",
            loadUtilsOnInit: "https://cdn.jsdelivr.net/npm/intl-tel-input@24.5.0/build/js/utils.js", 
            separateDialCode: true, 
            width: "100%",
        });
        $(phoneInput).data('intl', iti);
    }
    // --- REUSABLE VALIDATION FUNCTION ---
    function validateForm(formSelector) {
        let isValid = true;
        let errorMessage = "Kindly check and fill all required fields";
        const $form = $(formSelector);
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const MIN_YEAR = 1920;
    
        // 1. Validate inputs, selects, and textareas
        $form.find(`input[type="text"][required], 
            input[type="email"][required], 
            input[type="password"], 
            input[type="date"][required], 
            select[required], 
            textarea[required]`).each(function() {
            const $el = $(this);
            const value = $el.val() ? $el.val().trim() : "";
            
            // --- SELECTRIC HANDLING ---
            if ($el.is('select')) {
                // Remove error from the Selectric wrapper specifically
                $el.next('.select2-container').find('.select2-selection').removeClass('error');
            } else {
                $el.removeClass('error');
            }
        
            if (value === ""|| value === null) {
                isValid = false;
                // Field is empty
                if ($el.is('select')) {
                    // Apply error to Selectric wrapper so it's visible
                    $el.next('.select2-container').find('.select2-selection').addClass('error');
                } else {
                    $el.addClass('error');
                }

                // Don't overwrite a specific message (like email) with a generic one
                if (errorMessage === "Kindly check and fill all required fields") {
                    errorMessage = "Kindly check and fill all required fields";
                }
    
            } else if ($el.attr('type') === 'email' && !emailRegex.test(value)) {
                // Field has content, but it's a bad email
                $el.addClass('error');
                isValid = false;
                errorMessage = "Please enter a valid email address.";
            } else if ($el.attr('type') === 'date'){
                const selectedYear = new Date(value).getFullYear();
                if (selectedYear < MIN_YEAR) {
                    $el.addClass('error');
                    isValid = false;
                    errorMessage = `Please check Date of birth.`;
                }
            }
        });
    
        // 2. Phone Validation Fix
        const $phoneField = $form.find('input[name="phone_number"], input[name="login-identifier"][type="tel"]');
        if ($phoneField.length > 0 && $phoneField.attr('type') === 'tel') {
            const phoneVal = $phoneField.val().trim();            
            // Reset state
            $phoneField.removeClass('error');

            if (phoneVal === "") {
                $phoneField.addClass('error');
                isValid = false;
            } else {
                // Use the instance tied to this specific element
                const currentIti = $phoneField.data('intl') || loginIti;

                // 1. Check for alphabetic characters (Regex fallback)
                if (/[a-zA-Z]/.test(phoneVal)) {
                    $phoneField.addClass('error');
                    isValid = false;
                    errorMessage = "Phone number must contain only digits.";
                } 
                // 2. Use the Plugin Validation
                else if (typeof iti !== 'undefined' && iti !== null) {
                    const isValidNumber = iti.isValidNumber();
                    const errorCode = iti.getValidationError();
        
                    if (!isValidNumber) {
                        $phoneField.addClass('error');
                        isValid = false;
        
                        // Map the error codes using the internal Utils (v24 syntax)
                        if (window.intlTelInputUtils) {
                            const errorType = window.intlTelInputUtils.validationError;
                            switch (errorCode) {
                                case errorType.TOO_SHORT: errorMessage = "The phone number is too short."; break;
                                case errorType.TOO_LONG: errorMessage = "The phone number is too long."; break;
                                default: errorMessage = "Please enter a valid phone number.";
                            }
                        } else {
                            errorMessage = "Invalid phone number format.";
                        }
                    }
                }
            }
            
        }
        
        if (!isValid) {
            showToast(`<h4 class="red">Validation Error</h4><p>${errorMessage}</p>`);
        }
        return isValid;
    }

    // 1. Handle User Details Update
    $('#user_details_form button').on('click', function(e) {
        e.preventDefault();
    
        var $form = $('#user_details_form');
    
        // RUN VALIDATION: If false, stop execution immediately
        if (!validateForm('#user_details_form')) {
            return;
        }
    
        // Collect data from the form
        var userData = {
            "first_name":    $form.find('[name="first_name"]').val(),
            "last_name":     $form.find('[name="last_name"]').val(),
            "email":         $form.find('[name="email"]').val(),
            "phone_number":  iti.getNumber(),
            "date_of_birth": $form.find('[name="date_of_birth"]').val(), // Added
            "gender":        $form.find('[name="gender"]').val()         // Added
        };
    
        $.ajax({
            url: '/api/accounts/update',
            type: 'POST',
            headers: {
                'accept': 'application/json' // Matches your curl requirement
            },
            contentType: 'application/json',
            data: JSON.stringify(userData),
            success: function() {
                showToast(`<h4 class="red">User details</h4><p>Updated successfully.</p>`);
            },
            error: function(xhr) {
                console.error('Error:', xhr.responseText);
                showToast(`<h4 class="red">User details</h4><p>Failed to update details.</p>`);
            }
        });
    });

    // ---------------------------------------------------------

    // 2. Handle Password Update
    $('#password_update_form button').on('click', function(e) {
        e.preventDefault();

        // RUN VALIDATION: If false, stop execution immediately
        if (!validateForm('#password_update_form')) {
            return;
        }

        var passwordData = {
            "old_password": $('#password_update_form').find('[name="old_password"]').val(),
            "new_password": $('#password_update_form').find('[name="new_password"]').val()
        };

        $.ajax({
            url: '/api/accounts/change-password',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(passwordData),
            success: function() {
                showToast(`<h4 class="red">User Password</h4><p>Changed successfully.</p>`);
                $('#password_update_form').trigger('reset');
            },
            error: function(xhr) {
                console.error('Error:', xhr.responseText);
                // Tip: It is safer to show a generic error message or parse the specific error
                showToast(`<h4 class="red">User Password</h4><p>${xhr.responseText || 'Failed to change password'}</p>`);
                $('#password_update_form').trigger('reset');
            }
        });
    });

    // ---------------------------------------------------------
    // 3. Searchbar

    // --- 1. Setup Variables ---
    let typingTimer;
    const doneTypingInterval = 500;// Cache selectors    
    const $resultsContainer = $('.searchDrop');
    const $resultsList = $('.searchDrop ul');
    const $allSearchInputs = $('#searchbar input, .searchDrop .searchInside input');

    // --- 2. Function: Live Search (API Call) ---
    function fetchResults(query) {
        $.ajax({
            url: '/api/catalogue/products',
            type: 'GET',
            data: { page: 1, page_size: 5, search: query, available_only: true },
            headers: { 'accept': 'application/json' },
            success: (response) => renderDropdown(response, query),
            error: (xhr) => console.error('Search error:', xhr.responseText)
        });
    }

    // --- 3. Function: Full Search (Redirect) ---
    // Updated to accept the specific input element being used
    function submitSearch(activeInput) {
        const input = activeInput || '#searchbar input';
        const val = $(input).val();
        const query = val ? val.trim() : '';
        if (query.length > 0) {
            window.location.href = '/catalogue/?q=' + encodeURIComponent(query);
        }
    }

    // --- 4. Logic: User Stopped Typing ---
    function doneTyping(activeInput) {
        const searchTerm = $(activeInput).val().trim();
        if (searchTerm.length >= 3) {
            fetchResults(searchTerm);
        } else {
            if (!isMobile(880)) {
                $resultsContainer.hide();
            }
        }
    }

    // --- 5. Event Listeners ---

    // Unified input handler
    $allSearchInputs.on('input', function() {
        const self = this; // Capture the specific input
        clearTimeout(typingTimer);
        typingTimer = setTimeout(() => doneTyping(self), doneTypingInterval);
    });

    // Enter Key & Focus
    $allSearchInputs.on('keydown', function(e) {
        if (e.which === 13) {
            e.preventDefault();
            clearTimeout(typingTimer);
            submitSearch(this);
        }
    }).on('focus', function() {
        const val = $(this).val().trim();
        if (val.length >= 3) {
            $resultsList.children().length > 0 ? $resultsContainer.show() : fetchResults(val);
        }
    });

    // Mobile Trigger
    $('.js-trigger-mobile-search').on('click', function(e) {
        e.preventDefault();
        if (isMobile(880)) {
            $resultsContainer.show();
            // Focus the mobile-specific input inside the dropdown
            $('.searchDrop .searchInside input').focus();
        }
    });

    // Close Actions
    $('.js-close-search').on('click', (e) => {
        e.preventDefault();
        $resultsContainer.hide();
    });

    // Close when clicking outside
    $(document).on('click', function(e) {
        if (isMobile(880)) return; // On mobile, only .js-close-search closes it
        
        if (!$(e.target).closest('.search, .searchDrop, .js-trigger-mobile-search').length) {
            $resultsContainer.hide();
        }
    });

    // --- Function: Render Results ---
    function renderDropdown(response, query) {
        $resultsList.empty();

        if (response.products && response.products.length > 0) {
            response.products.forEach(product => {
                $resultsList.append(`
                    <li class="product">
                        <a href="${product.absolute_url}">
                            <div class="product-image"><img src="${product.primary_image}" alt="${product.title}" /></div>
                            <div class="product-info">${product.title}</div>
                        </a>
                    </li>`);
            });
            $resultsList.append(`<li><a href="/catalogue/?q=${encodeURIComponent(query)}" class="button outline unrounded">View All Results</a></li>`);
        } else {
            $resultsList.append('<li class="hard">No results found</li><li>Check your spelling or try simple keywords</li>');
        }
        $resultsContainer.show();
    }

    

    // ---------------------------------------------------------

    // 4. Handle Contact Form Submission
    $('#contact-form button').on('click', function(e) {
        e.preventDefault();

        // Use the existing validation helper
        if (!validateForm('#contact-form')) {
            return;
        }
        
        // Manual check for Textarea (since validateForm only checks <input>)
        const $messageBox = $('#contact-form').find('textarea[name="message"]');
        if ($messageBox.val().trim() === "") {
            $messageBox.addClass('error');
            showToast(`<h4 class="red">Required</h4><p>Please enter a message</p>`);
            return;
        } else {
            $messageBox.removeClass('error');
        }

        // Prepare the data
        var contactData = {
            "first_name": $('#contact-form').find('[name="first_name"]').val(),
            "last_name":  $('#contact-form').find('[name="last_name"]').val(),
            "email":      $('#contact-form').find('[name="email"]').val(),
            "phone":      $('#contact-form').find('[name="phone"]').val(),
            "message":    $('#contact-form').find('[name="message"]').val()
        };

        // Send API Request
        $.ajax({
            url: '/api/contact-us/',
            method: 'POST', // standard is method, type works too
            contentType: 'application/json',
            data: JSON.stringify(contactData),
            success: function() {
                showToast(`<h4 class="red">Message Sent</h4><p>We will get back to you shortly.</p>`);
                $('#contact-form').trigger('reset'); // Clear the form
            },
            error: function(xhr) {
                console.error('Error:', xhr.responseText);
                showToast(`<h4 class="red">Error</h4><p>Could not send message. Please try again.</p>`);
            }
        });
    });

    // 1. Handle "Enter" Key press inside the input
    $('#searchbar input').on('keypress', function(e) {
        if (e.which === 13) { // 13 is the Enter key code
            e.preventDefault(); // Prevent default form submission if applicable
            submitSearch(this);
        }
    });

    // 2. Handle Click on the SVG icon
    $('#searchbar svg').on('click', function() {
        submitSearch('#searchbar input');
    });

    $(document).on('click', '.js-submit-address-form', function(e) {
        e.preventDefault();

        const $btn = $(this);
        const $form = $btn.closest('form');
        const address_id = $form.data('address-id');
        const isNew = !address_id || address_id === 'new';
        
        // Find the phone input and get the ITI instance we stored in $(document).ready
        const $phoneInput = $form.find('input[name="phone_number"]');
        const itiInstance = $phoneInput.data('intl');

        // 1. Reset UI
        $('.add_pin').removeClass('error');
        $form.find('.error').removeClass('error');

        // 2. Validation
        if (!validateForm($form)) return false;

        const lat = $('#id_latitude').val();
        const lng = $('#id_longitude').val();
        const reverse_geocode = $('#id_reverse_geocode').val();

        if (!lat || !lng) {
            $('.add_pin').addClass('error');
            showToast(`<h4 class="red">Error</h4><p>Please pin your location on the map.</p>`);
            return false;
        }

        // 3. Prepare Data
        const addressData = {
            first_name: $('#id_first_name').val(),
            last_name: $('#id_last_name').val(),
            line1: $('#id_line1').val(),
            line2: $('#id_line2').val(),
            latitude: lat,
            longitude: lng,
            reverse_geocode: reverse_geocode,
            phone_number: itiInstance ? itiInstance.getNumber() : $phoneInput.val(),
            tag: $('#id_tag').val(),
            notes: $('#address_notes').val()|| "",
        };

        // 4. UI Feedback
        $btn.prop('disabled', true).addClass('loading');

        // 5. Unified AJAX Call
        $.ajax({
            method: isNew ? 'POST' : 'PUT',
            url: isNew ? '/api/address/add/' : `/api/address/update/?address_id=${address_id}`,
            headers: {
                'X-CSRFToken': typeof csrf_token !== 'undefined' ? csrf_token : '',
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(addressData),
        })
        .done(function(data){
            showToast(`<h4 class="red">${isNew ? 'Added New': 'Edited Your'} Address</h4><p>Successful!</p>`);
            setTimeout(() => window.location.href = '/accounts/addresses/', 1000); 
        })
        .fail(function(xhr) {
            $btn.prop('disabled', false).removeClass('loading');

            let errorMsg = "Action failed. Please try again.";
            
            if (xhr.responseJSON) {
                const data = xhr.responseJSON;
                
                // FIX: Check if the error is a string or an object (Django Rest Framework style)
                if (typeof data === 'string') {
                    errorMsg = data;
                } else if (data.message || data.detail) {
                    errorMsg = data.message || data.detail;
                } else {
                    // We pick the first available error message
                    const firstKey = Object.keys(data)[0];
                    errorMsg = Array.isArray(data[firstKey]) ? data[firstKey][0] : data[firstKey];
                    
                    // Highlight the specific field that failed
                    $form.find(`[name="${firstKey}"]`).addClass('error');
                }

                // Safe check before toLowerCase
                const lowerMsg = String(errorMsg).toLowerCase();
                console.log(lowerMsg)
                if (lowerMsg.includes("email")) $form.find('input[name="email"]').addClass("error");
                if (lowerMsg.includes("phone")) $form.find('input[name="phone_number"]').addClass("error");
                if (lowerMsg.includes("no delivery store")) $('.add_pin').addClass('error');
            }

            showToast(`<h4 class="red">Address Error</h4><p style="-webkit-line-clamp: 3;">${errorMsg}</p>`);
        });
    }).on('click', '#password_update_form button', function(e) {
        const $form = $(this).closest('form');

        // Use the existing validation helper
        if (!validateForm($form)) {
            e.preventDefault();
            return false;
        }else{
            return true;
        }
    }).on('click', '#login_form button[type="submit"]', function(e){
        const $form = $(this).closest('form');
        const $input = $('#id_check_type');

        if (!validateForm($form)) {
            e.preventDefault();
            return false;
        }

        const isPhoneMode = $input.attr('type') === 'text' && $input.attr('name') === 'phone-number';

        // Final check: if phone mode is active, update the hidden login-identifier
        if (loginIti && isPhoneMode) {
            let $hidden = $form.find('input[name="login-identifier"][type="hidden"]');
            if (!$hidden.length) {
                $form.append(`<input type="hidden" name="login-identifier">`);
                $hidden = $form.find('input[name="login-identifier"][type="hidden"]');
            }
            const fullNumber = loginIti.getNumber();
            $hidden.val(fullNumber);
        }
        
        return true;
    }).on('click', '#register_form button[type="submit"]', function(e){
        e.preventDefault(); // Prevent standard form submission
        const $form = $(this).closest('form');
        
        if (!validateForm($form))  return false; // 1. Run validation

        // 2. Collect and Map Data
        const registrationData = {
            "email": $form.find('[name="email"]').val().trim(),
            "first_name": $form.find('[name="first_name"]').val().trim(),
            "last_name": $form.find('[name="last_name"]').val().trim(),
            "phone_number": (typeof iti !== 'undefined') ? iti.getNumber() : $form.find('[name="phone_number"]').val(),
            "gender": $form.find('[name="gender"]').val(),
            "date_of_birth": $form.find('[name="date_of_birth"]').val(),
        };

        // 3. AJAX Submission (Matches your CURL command)
        $.ajax({
            url: '/api/accounts/register',
            type: 'POST',
            headers: {
                'accept': 'application/json'
            },
            contentType: 'application/json',
            data: JSON.stringify(registrationData),
            beforeSend: function() {
                $form.find('button').prop('disabled', true);
            },
            success: function() {         
                showToast(`<h4 class="red">User Registration</h4><p>Registraion completed.</p>`);  
                $form[0].reset();     
                // Redirect after a short delay so they see the toast
                setTimeout(() => {
                    window.location.href = '/accounts/addresses/add/';
                }, 500);
            },
            error: function(xhr) {
                $form.find('button[type="submit"]').prop('disabled', false).removeClass('loading');
                
                let errorMsg = "Registration failed. Please try again.";
                if (xhr.responseJSON) {
                    errorMsg = xhr.responseJSON.message || (xhr.responseJSON.detail) || JSON.stringify(xhr.responseJSON);

                    // 2. Specific field highlighting logic
                    const lowerMsg = errorMsg.toLowerCase();
                    
                    if (lowerMsg.includes("password"))  $form.find('input[name="password1"]').addClass("error");
                    
                    if (lowerMsg.includes("email"))  $form.find('input[name="email"]').addClass("error");
                    
                    if (lowerMsg.includes("phone")) $form.find('input[name="phone_number"]').addClass("error");
                }
                showToast(`<h4 class="red">Error</h4><p>${errorMsg}</p>`);
            }
        });
    });

    // --- LOGIN IDENTIFIER SWITCHER (Email vs Phone) ---
    const $loginInput = $('#id_check_type');
    let loginIti = null;

    // Helper to initialize ITI
    const initPhoneMode = () => {
        if (!loginIti && $loginInput.length > 0) {
            loginIti = window.intlTelInput($loginInput[0], {
                initialCountry: "ae",
                loadUtilsOnInit: "https://cdn.jsdelivr.net/npm/intl-tel-input@24.5.0/build/js/utils.js",
                separateDialCode: true,
                // Ensure it takes full width of your container
                width: "100%" 
            });
            $loginInput.data('intl', loginIti);
        }
    };

    // 1. Initialize immediately on load
    initPhoneMode();

    // 2. Manage the hidden identifier for the backend
    const syncHiddenInput = (remove = false) => {
        const $form = $loginInput.closest('form');
        $form.find('input[name="login-identifier"][type="hidden"]').remove();
        if (!remove && loginIti) {
            $form.append(`<input type="hidden" name="login-identifier" value="">`);
        }
    };

    // Initial sync in case there's a pre-filled value
    syncHiddenInput();

    // 3. The Switcher Logic
    $loginInput.on('input', function() {
        const $el = $(this);
        const value = $el.val().trim();
        const selectionStart = $el[0].selectionStart;

        const restoreState = () => {
            $el.focus();
            if ($el[0].setSelectionRange) {
                $el[0].setSelectionRange(selectionStart, selectionStart);
            }
        };

        // --- SWITCH TO PHONE (If numeric or empty) ---
        if (value.length === 0 || (/^\+?\d+$/.test(value) && !value.includes('@'))) {
            if ($el.attr('type') !== 'tel') {
                initPhoneMode();
                $el.attr({
                    'type': 'text',
                    'placeholder': '50 000 0000',
                    'name': 'phone-number'
                });
                syncHiddenInput();
                restoreState();
            } else {
                syncHiddenInput(); // Update hidden value as they type
            }
            return;
        }

        // --- SWITCH TO EMAIL (If letters or @ detected) ---
        if (value.length >= 2 && (/[a-zA-Z]/.test(value) || value.includes('@'))) {
            if ($el.attr('type') !== 'email') {
                if (loginIti) {
                    loginIti.destroy();
                    loginIti = null;
                }
                $el.attr({
                    'type': 'email',
                    'placeholder': 'Email address',
                    'name': 'login-identifier' // Backend primary key
                });
                syncHiddenInput(true); // Remove hidden input
                restoreState();
            }
        }
    });

    // --- 2FA METHOD DISPLAY ---
    const $optMethod = $('.js-opt-method');
    if ($optMethod.length > 0) {
        // Get current URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const method = urlParams.get('method');

        if (method) {
            // Capitalize first letter for better UI (e.g., "whatsapp" to "Whatsapp")
            const formattedMethod = method.charAt(0).toUpperCase() + method.slice(1);
            $optMethod.text(formattedMethod);
        }
    }

    $(document).on('click', '.js-switch-address', function(e){
        e.preventDefault();
        const address_url = $(this).attr('href');
        $('.address_switcher_info').addClass('open');
        $('body').addClass('locked');
        $('.js-confirm-change-address').attr('data-url', address_url);
    }).on('click', '.js-close-address_switcher', function(e){
        e.preventDefault();

        $('.address_switcher_info').removeClass('open');
        $('body').removeClass('locked');
    }).on('click', '.js-confirm-change-address', function(e){
        e.preventDefault();
        const $url = $(this).data('url');
        $(this).addClass('disabled');
        window.location.href = $url;
    }).on('click', '#subscribe-form button', function(e){
        e.preventDefault();
        const $form = $('#subscribe-form');

        if (!validateForm($form)) return;

        const email = $form.find('[name="subscribe_email"]').val().trim();

        $.ajax({
            url: `/api/newsletter/subscribe?email=${email}`,
            type: 'POST',
            headers: {'accept': 'application/json' },            
            success: function() {                
                showToast(`<h4 class="red">Email Subscription</h4><p>Successful!</p>`);
                $form[0].reset();
            },
            error: function(xhr) {
                console.error('Error fetching states:', xhr.responseText);
            }
        });
    });

    if ($('.accounts_loyalty .loyalty .history').length > 0) {
        $.ajax({
            url: `/api/accounts/points/history`,
            type: 'GET',
            headers: {
                'accept': 'application/json'
            },
            success: function(data) {
                const container = $('#loyalty-history-list');
                container.empty(); // Clear "Loading..." text
    
                if (data.length === 0) {
                    container.append('<p>No transaction history found.</p>');
                    return;
                }
                const rowHeading = `
                    <p class="transaction-row-heading">
                        <span class="type-label">Type</span> 
                        <span>Date</span> 
                        <span>Points</span>
                    </p>
                `;

                container.append(rowHeading);
    
                data.forEach(function(tx) {
                    // Format the Date (e.g., 24 Jan 2026)
                    const dateObj = new Date(tx.created_at);
                    const formattedDate = dateObj.toLocaleDateString('en-GB', {
                        day: '2-digit', month: 'short', year: 'numeric'
                    });
    
                    // Logic for color coding
                    // In your API: Credits add points, Debits subtract points
                    const isCredit = tx.type === 'credit';
                    const statusClass = isCredit ? 'primary' : 'secondary';
                    const sign = isCredit ? '+' : '-';
    
                    // Create the row structure
                    const row = `
                        <p class="transaction-row">
                            <span class="type-label">${tx.type}</span> 
                            <span>${formattedDate}</span> 
                            <span class="${statusClass}">${sign}${tx.points}</span>
                        </p>
                    `;
                    
                    container.append(row);
                });
            },
            error: function(xhr) {
                console.error('Error fetching history:', xhr.responseText);
                $('#loyalty-history-list').html('<p>Error loading history.</p>');
            }
        });
    }

    $(document).on('click', '.password .password-icon', function(e){
        e.preventDefault();
        
        const $container = $(this).closest('.password');
        const $input = $container.find('input');
        
        // Check the current state of the input
        const isPassword = $input.attr('type') === 'password';

        if (isPassword) {
            // Switch to visible text
            $input.attr('type', 'text');
            $container.removeClass('hidden').addClass('showing');
        } else {
            // Switch back to masked password
            $input.attr('type', 'password');
            $container.removeClass('showing').addClass('hidden');
        }
    })

    $('.rating-container .star').on('click', function() {
        // 1. Get the value from the clicked star
        const val = $(this).attr('data-value');
        
        // 2. Find the hidden input and set the value
        const $input = $('input[name="review_score"]');
        $input.val(val);

        // 3. Visual Update: 
        // Remove 'filled' from all stars in this group
        $(this).siblings().removeClass('filled');
        $(this).removeClass('filled');
        
        // Add 'filled' to current star and all previous siblings
        $(this).addClass('filled');
        $(this).prevAll().addClass('filled');

        // 4. Console log the value directly from the input to verify
        console.log("Current Rating stored:", $input.val());
    });
    $(document).on('click', '.js-open-review-form', function(e){
        e.preventDefault();
        $('body').addClass('locked');
        $('.review_form').addClass('open');
    }).on('click', '.js-close-review-form', function(e){
        e.preventDefault();
        $('.review_form').removeClass('open');
        $('body').removeClass('locked');
    }).on('click', '.js-submit-review', function(e){
        e.preventDefault();
        const $form = $(this).closest('form');
        const $productId = $(this).attr('data-product-id')
        // Use the existing validation helper
        if (!validateForm($form)) return;

        const $stars = $('input[name="review_score"]');
        if(!$stars.val() || $stars.val() === "0"){         
            showToast(`<h4 class="red">Validation Error</h4><p>Star rating missing.</p>`);
            return;
        }

        const $review = {
            "score": $stars.val(),
            "title": $('input[name="review_title"]').val(),
            "body":  $('textarea[name="review_body"]').val(),
            "name":  $('input[name="review_name"]').val()
        }

        $.ajax({
            url: `/api/catalogue/products/${$productId}/reviews`,
            method: 'POST',
            headers: {
                'X-CSRFToken': typeof csrf_token !== 'undefined' ? csrf_token : '',
                'Content-Type': 'application/json'
            },
            data: JSON.stringify($review),
        })
        .done(function(data){            
            $('.review_form').removeClass('open');
            $('body').removeClass('locked');
            setTimeout(() => {
                showToast(`<h4 class="red">Product Review</h4><p>Submitted successfully!</p>`);
            }, 500);
        })
        .fail(function(xhr) {            
            if (xhr.responseJSON) {
                const data = xhr.responseJSON;
                
                // FIX: Check if the error is a string or an object (Django Rest Framework style)
                if (typeof data === 'string') {
                    errorMsg = data;
                } else if (data.message || data.detail) {
                    errorMsg = data.message || data.detail;
                } else {
                    // We pick the first available error message
                    const firstKey = Object.keys(data)[0];
                    errorMsg = Array.isArray(data[firstKey]) ? data[firstKey][0] : data[firstKey];
                    
                    // Highlight the specific field that failed
                    $form.find(`[name="${firstKey}"]`).addClass('error');
                }

                // Safe check before toLowerCase
                const lowerMsg = String(errorMsg).toLowerCase();
                console.log(lowerMsg)
            }
            
            $('.review_form').removeClass('open');
            $('body').removeClass('locked');
            setTimeout(() => {
                showToast(`<h4 class="red">Review Error</h4><p style="-webkit-line-clamp: 3;">${errorMsg}</p>`);
            }, 500);
        });
    })

    
    
});

$(window).on('load resize', function() {
    function alignSearchDrop() {
        const $searchForm = $('.search .form');
        const $searchDrop = $('.searchDrop');
    
        // Only apply custom alignment above 880px
        if ($(window).width() > 880) {
            if ($searchForm.length > 0){
                const rect = $searchForm[0].getBoundingClientRect();
                const formHeight = $searchForm.outerHeight();
                
                // We add a small gap (e.g., 5px) so it doesn't touch the input perfectly
                const topPos = rect.top + formHeight + 5; 
                const leftPos = rect.left;
                const formWidth = $searchForm.outerWidth();
        
                $searchDrop.css({
                    'top': topPos + 'px',
                    'left': leftPos + 'px',
                    'width': formWidth + 'px', // Matches width of search bar
                    'transform': 'none',        // Reset the CSS translateX
                    'margin': '0'
                });
            }
        } else {
            // Reset to default mobile styles (fixed at top 85px as per your CSS)
            if($searchDrop.length > 0) $searchDrop.css({'top': '','left': '','width': '','transform': '','margin': ''});
        }
    }

    alignSearchDrop();
})